<template>
  <div>

    <Loader :visible="isLoading" :text="loadingText" />

    <ConfirmationModal :show="showBarCodeModal" @close="showBarCodeModal = false">
        <template #title>
            {{ $t('core.item_search') }}
        </template>

        <template #content>
          <div v-if="singlebarcode">
            {{ $t('gm.scan_barcode_to_increment') }} {{ itemRef?.Item }} <br>
            <input v-model="tmpQty" class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" disabled type="number">
            ({{ itemRef?.Qty }} {{ $t('core.in_order') }}.)
          </div>
          <div v-else>
            {{ $t('core.qty_received_of') }} {{ itemRef?.Item }} <br>
            <input v-model="tmpQty" class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" onfocus="this.select()" type="number" ref="barcodeQtyInput">
            ({{ itemRef?.Qty }} {{ $t('core.in_order') }}.)
          </div>
        </template>

        <template #footer>
            <SecondaryButton @click="showBarCodeModal = false">
                {{ $t('core.cancel') }}
            </SecondaryButton>

            <PrimaryButton
                class="ms-3"
                @click="itemRef.CommitQty = tmpQty; barcodeSearch = '', showBarCodeModal = false"
            >
                {{ $t('core.set') }}
            </PrimaryButton>
        </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showSaveModal" @close="showSaveModal = false">
        <template #title>
            {{ $t('gm.confirm_bol') }}
        </template>

        <template #content>
          <div>
            {{ $t('gm.confirm_bol_description') }}
          </div>
        </template>

        <template #footer>
            <SecondaryButton @click="showSaveModal = false">
                {{ $t('actions.cancel') }}
            </SecondaryButton>
            <PrimaryButton
                class="ms-3"
                @click="Save"
            >
                {{ $t('core.save') }}
            </PrimaryButton>
        </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showQtyDiffModal" @close="showQtyDiffModal = false">
      <template #title>
        {{ $t('gm.confirm_mismatched_quantities') }}
      </template>
      <template #content>
        {{ $t('gm.confirm_mismatched_quantities_description') }}
        <ul class="mt-2 text-xs text-gray-600">
          <li v-for="row in qtyDiffRows" :key="row.Item">
            {{ $t('core.order') }}: {{ row.InternalOrdNo || row.PurchaseOrdId }}, {{ $t('core.item') }}: {{ row.Item }}<br>
            {{ $t('core.qty_order') }}: {{ row.Qty }}, {{ $t('core.qty_registered') }}: {{ row.DeliveredQty }}, {{ $t('core.qty_to_register') }}: {{ row.CommitQty }}
          </li>
        </ul>
      </template>
      <template #footer>
        <SecondaryButton @click="showQtyDiffModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton class="ms-3" @click="showQtyDiffModal = false; Save()">
          {{ $t('actions.confirm_and_save') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showConfirmBinModal" @close="showConfirmBinModal = false">
      <template #title>
        {{ $t('gm.confirm_bin') }}
      </template>
      <template #content>
        <div>
          {{ $t('gm.insert_bin_to_confirm') }}<br>
          <input 
            v-model="tmpBinConfirm" 
            class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2" 
            ref="confirmBinInput"
            @keydown.enter="$refs.confirmBinInput.blur()"
            onfocus="this.select()"
          >
        </div>
        <div v-if="tmpBinConfirm === items[itemConfirmBinIndex]?.Bin" class="mt-4">
          {{ $t('core.qty_to_register') }} <br>
          <input 
            v-model="tmpQty" 
            class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2" 
            type="number"
            onfocus="this.select()"
          >
        </div>
        <label v-if="tmpQty > 0 && tmpQty != items[itemConfirmBinIndex]?.Qty" class="text-red-600 text-sm mt-2 block">
          {{ $t('gm.qty_differs_from_bol') + ' (' + items[itemConfirmBinIndex]?.Qty + ')' }}
        </label>
      </template>
      <template #footer>
        <SecondaryButton @click="showConfirmBinModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton 
          class="ms-3" 
          :disabled="tmpBinConfirm !== items[itemConfirmBinIndex]?.Bin || Number(tmpQty) != Number(items[itemConfirmBinIndex]?.Qty)"
          @click="assignItemConfirmBin"
        >
          {{ $t('core.set') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>

    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <h2 class="text-lg font-semibold mb-2">{{ $t('core.billofladings') }}:</h2>
      <ul class="mb-4 text-sm">
        <li v-for="order in GetOrderList()" :key="order" class="inline-block mr-2 bg-blue-100 rounded px-3 py-1 mb-1">{{ order }}</li> 
      </ul>
      <!--<div class="mb-6">
        <div class="relative">
          <input 
            ref="barcodeInput"
            v-model="barcodeSearch" 
            type="text" 
            :placeholder="$t('core.barcode_search') + '...'" 
            class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            @keyup.enter="searchItemfromBarcode"
            autofocus
          >
          <div class="absolute right-3 top-3 text-gray-400">
            <i class="fa fa-search"></i>
          </div>
        </div>
      </div>-->
      <div class="flex items-center justify-between mb-4">
        <label class="block text-sm font-medium mb-2">{{ $t('core.items_list') }}</label>
      </div>

      <PageNormalTable
        :headers="headers" 
        :items="regularItems" 
        :sort-by="sortby" 
        :item-value="item => `${item.PurchaseOrdId}-${item.Position}`"
        hide-default-footer
        multi-sort
        :mobile-filter-exclusions="['Qty', 'DeliveredQty', 'CommitQty', 'Lot']"
        :row-props="getRowProps"
        >
        <template #item.CommitQty="{ item, index }">
            <div v-if="!required_bin || (item.Bin != null && item.Bin != '')">
              <span v-if="!item.ICAM_Row || item.StatusCode == '9'">
                  <input type="number" v-if="!confirm_bin || item.Bin == null || item.Bin == ''" class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" v-model="item.CommitQty" onfocus="this.select()">
                  <button v-else class="bg-blue-300 hover:bg-blue-500 text-white px-4 py-2 rounded" @click="showBinConfirm(item)">{{ $t('core.confirm') }}</button>
              </span>
              <span v-else-if="(item.Bin != null && item.Bin != '') && (item.StatusCode == null || item.StatusCode == '8')">
                  <button class="bg-blue-300 hover:bg-blue-500 text-white px-4 py-2 rounded" @click="sendIcamRequest(item)">{{ $t('gm.send_request') }}</button>
              </span>
              <span v-else-if="(item.Bin != null && item.Bin != '') && item.StatusCode == '5'">
                  <button class="bg-blue-300 hover:bg-blue-500 text-white px-4 py-2 rounded" @click="confirmIcamTaken(item)">{{ $t('gm.confirm_placing') }}</button>
              </span>
            </div>
        </template>
        <template #item.StatusCode="{ item }">
            <span>
              {{ getStatusCodeLabel(item) }}
            </span>
        </template>
        <template #item.Lot="{ item }">
            <div class="flex gap-2">
                <input type="text" class="flex-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" v-model="item.Lot">
                <button 
                    @click="generateLot(item)" 
                    class="px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors" 
                    :title="$t('core.generate_lot')"
                >
                    <i class="fa fa-magic"></i>
                </button>
            </div>
        </template>
      </PageNormalTable>
      <div v-if="pickingItems.length > 0" class="mt-8">
        <div class="flex items-center justify-between mb-4">
          <label class="block text-sm font-medium mb-2">Articoli in Picking → <span class="font-bold text-blue-600">SPED</span></label>
        </div>
        <PageNormalTable
          :headers="headers.filter(h => h.key != 'StatusCode')"
          :items="pickingItems"
          :sort-by="sortby"
          :item-value="item => `${item.PurchaseOrdId}-${item.Position}`"
          hide-default-footer
          multi-sort
          :row-props="getRowProps"
        >
          <template #item.CommitQty="{ item, index }">
            <div v-if="!required_bin || (item.Bin != null && item.Bin != '')">
              <span>
                <input type="number" v-if="!confirm_bin || item.Bin == null || item.Bin == ''" class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" v-model="item.CommitQty" onfocus="this.select()">
                <button v-else class="bg-blue-300 hover:bg-blue-500 text-white px-4 py-2 rounded" @click="showBinConfirm(item)">Conferma</button>
              </span>
            </div>
          </template>
          <template #item.StatusCode="{ item }">
            {{ getStatusCodeLabel(item) }}
          </template>
          <template #item.Lot="{ item }">
            {{ item.Lot }}
          </template>
          <template #item.Actions="{ item }">
            <div class="flex items-center gap-3">
              <!-- Pulsante Etichetta (Stile Primario) -->
              <button 
                  @click="printLabelPicking(item)" 
                  class="inline-flex items-center gap-2 px-2 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-md shadow-sm transition-all active:scale-95 group"
                  title="Stampa Etichetta"
              >
                  <v-icon name="co-print" scale="0.8" class="opacity-90 group-hover:scale-110 transition-transform" />
                  <span>Etichetta</span>
              </button>

              <!-- Pulsante Picking List (Stile Light/Bordato) -->
              <button 
                  @click="printPicking(item)" 
                  class="inline-flex items-center gap-2 px-2 py-2 bg-white hover:bg-gray-100 text-gray-700 border border-gray-300 text-xs font-semibold rounded-md shadow-sm transition-all active:scale-95 group"
                  title="Stampa Lista"
              >
                  <v-icon name="co-print" scale="0.8" class="text-gray-400 group-hover:text-gray-600 transition-colors" />
                  <span>Picking List</span>
              </button>
            </div>
          </template>
          
        </PageNormalTable>
      </div>

      
      <div class="pb-24"></div>

      <div class="fixed left-0 right-0 bottom-0 flex justify-center items-center pointer-events-none">
        <div class="flex gap-2 pointer-events-auto bg-white w-full px-4 py-3 justify-center">
             <button
              class="text-white bg-blue-400 hover:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              @click="onConfermaClick"
              :disabled="!hasAtLeastOneCommit"
            >
              {{ $t('actions.register') }}
            </button>
        </div>
      </div>
    </div>
  </div>
  <ToastNotification
  :show="toast.show"
  :message="toast.message"
  :type="toast.type"
  @update:show="toast.show = $event"
  />
</template>

<script setup>
import { ref } from 'vue';
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageNormalTable from '@/Components/PageNormalTable.vue';
import axios from 'axios';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';
import ToastNotification from '@/Components/ToastNotification.vue';
import Loader from '@/Components/Loader.vue';
import { CoBlur } from 'oh-vue-icons/icons';
</script>

<script>

export default {
  props: {
    items: Array,
    singlebarcode: Boolean,
    handleLots: Boolean,
    lotConfig: {
      type: Object,
      default: () => ({
        prefix: '',
        year_format: 'none',
        separator: '-',
        suffix: ''
      })
    },
    icam_support: Boolean,
    confirm_bin: Boolean,
    required_bin: Boolean,
  },
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    Loader,
    PageNormalTable,
    ToastNotification,
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('modules.conferma_bolle_carico'), href: route('modules.gm.confermabollecarico') }
      ],
      barcodeSearch: '',
      tmpBarcode: '',
      showBarCodeModal: false,
      showSaveModal: false,
      itemRef: undefined,
      tmpQty: 1,
      supplierDoc: '',
      supplierDate: '',
      //deletions: [],
      headers: [],
      sortby: [],
      ipp: 10,
      page: 1,
      showQtyDiffModal: false,
      qtyDiffRows: [],
      itemConfirmBinIndex: -1,
      showConfirmBinModal: false,
      tmpBinConfirm: '',
      toast: {
        show: false,
        message: '',
        type: 'success'
      },
      isLoading: false,
      loadingText: ''

    };
  },
  computed: {
    hasAtLeastOneCommit() {
      return this.items.some(row => Number(row.CommitQty || 0) > 0);
    },
    regularItems() {
      return this.items.filter(i => !i.IsPicking);
    },
    pickingItems() {
      return this.items.filter(i => i.IsPicking);
    },
  },
  methods: {
    GetOrderList()
    {
      return [...new Set(this.items.map(x=>x.DocNo))];
    },
    searchItemfromBarcode(){
      let _this = this;
      axios.post(route('modules.gm.cercabarcode'), { barcode: this.barcodeSearch }).
      then((response) => {
        if (response.data.length > 0)
        {
          var list = _this.items.filter(x=>x.Item == response.data[0].Item && x.CommitQty == 0);

          if (list.length > 0){
            _this.itemRef = list[0];
            _this.tmpQty = 1;
            _this.showBarCodeModal = true;
          }
          else{
            _this.showToast(_this.$t('gm.item_not_found_or_already_pickedup', { item: response.data[0].Item }), 'warning');
          }
        }
        else{
          _this.showToast(_this.$t('core.item_not_found'), 'error');
        }
      });
    },
    getRowProps(item)
    {
      return {
          class: (item.item.Bin == null || item.item.Bin == '') && this.required_bin ? 'bg-gray-100' : item.item.CommitQty > 0 ? 'bg-green-300' : '',
      };
    },
    async showBinConfirm(item) {
      this.itemConfirmBinIndex = this.items.indexOf(item);
      this.tmpBinConfirm = '';
      this.tmpQty = 0;
      this.showConfirmBinModal = true;
      this.$nextTick(() => {
          this.$refs.confirmBinInput.focus();
      });
    },

    assignItemConfirmBin(){
      this.items[this.itemConfirmBinIndex].CommitQty = Number(this.tmpQty);
      this.showConfirmBinModal = false;
    },
    onConfermaClick() {
      // Controlla se ci sono righe con CommitQty > 0 e CommitQty + DeliveredQty != Qty
      const diffRows = this.items.filter(
        row =>
          Number(row.CommitQty || 0) > 0 &&
          Number(row.CommitQty || 0) + Number(row.DeliveredQty || 0) !== Number(row.Qty || 0)
      );
      if (diffRows.length > 0) {
        this.qtyDiffRows = diffRows;
        this.showQtyDiffModal = true;
        this.showSaveModal = false;
      } else {
        this.showSaveModal = true;
      }
    },
    async Save()
    {
      // Validate lot field if lot management is enabled
      if (this.handleLots) {
        const itemsWithoutLot = this.items.filter(
          item => Number(item.CommitQty || 0) > 0 && (!item.Lot || item.Lot.trim() === '')
        );
        
        if (itemsWithoutLot.length > 0) {
          this.showToast(this.$t('core.lot_required'), 'error');
          this.showSaveModal = false;
          return;
        }
      }

      this.isLoading = true;
      this.loadingText = this.$t('core.saving_data') + '...';

      axios.post(route('modules.gm.salvaBolla'), { rows: this.items}).
      then((response) => {
        this.isLoading = false;
        if (response.data.success > 0)
        {
          this.showToast(this.$t('core.successful_operation'), "success");
          setTimeout(() => {
            router.get(route('modules.gm.confermabollecarico'));
          }, 1200);
        }
        else{
          this.showToast(this.$t('core.error'), 'error');
        }
      }).catch((error) => {
        this.isLoading = false;
        this.showToast(this.$t('core.error'), 'error');
      });
    },
    checkBarcode(){
      if (this.tmpBarcode == this.barcodeSearch) {
        this.tmpQty++;
      }
      else{
        this.showToast(this.$t('gm.barcode_mismatched'), 'error');
        //alert('');
      }
      this.tmpBarcode = '';
    },
    showToast(message, type = 'success') {
      this.toast.message = message;
      this.toast.type = type;
      this.toast.show = true;
    },
    generateLot(item) {
      if (!this.lotConfig) {
        this.showToast('Configurazione lotto non disponibile', 'error');
        return;
      }
      
      const searchPattern = this.buildSearchPattern();

      const usedLots = this.items
        .filter(row => row !== item && row.Lot && row.Lot.trim() !== '')
        .map(row => row.Lot.trim());

      axios.post(route('modules.gm.getNextLot'), { 
        prefix: searchPattern.prefix,
        suffix: searchPattern.suffix,
        item: item.Item,
        usedLots
      }).then((response) => {
        if (response.data.success) {
          const generatedLot = response.data.nextLot || response.data.lastLot;
          item.Lot = generatedLot;
          this.showToast('Lotto generato: ' + generatedLot, 'success');
        } else {
          this.showToast(this.$t('core.error'), 'error');
        }
      }).catch((error) => {
        this.showToast(this.$t('core.error'), 'error');
      });
    },
    buildSearchPattern() {
      const config = this.lotConfig;
      let searchPrefix = '';
      
      if (config.prefix && config.prefix.trim() !== '') {
        searchPrefix += config.prefix.trim();
      }

      if (config.year_format === '2-digit') {
        searchPrefix += new Date().getFullYear().toString().slice(-2);
      } else if (config.year_format === '4-digit') {
        searchPrefix += new Date().getFullYear().toString();
      }
      
      if (searchPrefix.length > 0 && config.separator && config.separator !== 'none') {
        searchPrefix += config.separator;
      }
      
      const searchSuffix = (config.suffix && config.suffix.trim() !== '') ? config.suffix.trim() : '';
      
      return {
        prefix: searchPrefix,
        suffix: searchSuffix
      };
    },
    getStatusCodeLabel(item) {
      if (!this.icam_support || !item.ICAM_Row) return '';
      else if (item.Bin == null || item.Bin == '')
        return 'Nessuna ubicazione';
      if (item.StatusCode)
      {
        switch(item.StatusCode) {
          case '0':
            return 'Creato';
          case '1':
            return 'Inviato a CPT Move';
          case '2':
            return 'Annullamento forzato';
          case '3':
            return 'Errore - ' + item.Status;
          case '4':
            return 'In lavorazione';
          case '5':
            return 'Ubicazione consentita';
          case '6':
            return 'Operazioni confermate';
          case '8':
            return 'Errore definitivo - ' + item.Status;
          case '9':
            return 'Concluso';
          default:
            return item.StatusCode;
        }
      }
      else return 'Da inviare';
    },
    async updateIcamStatus(){
      let _this = this;
      await axios.post(route('modules.gm.bolleDettagli'), { ids: [...new Set(this.items.map(x=>x.PurchaseDocId))], isUpdate: true}).then((response) => {
        if (response.data.success) {
          var temp = JSON.parse(JSON.stringify(_this.items));
          _this.items.splice(0, _this.items.length);
          _this.items.push(...response.data.items);

          temp.forEach(oldItem => {
            let newItem = _this.items.find(i => i.PurchaseDocId === oldItem.PurchaseDocId && i.Line === oldItem.Line);
            if (newItem) {
              if (newItem.StatusCode == '9' && oldItem.StatusCode != '9'){
                newItem.CommitQty = newItem.Qty;
              }
              else newItem.CommitQty = oldItem.CommitQty;
            }
          });
        }
      }).catch((error) => {
        this.showToast(this.$t('core.error'), 'error');
      });
      // Non usare setInterval perché per alcuni potrebbe metterci più di 10 secondi a rispondere e si rischierebbe di sovrapporre più chiamate
      setTimeout(this.updateIcamStatus, 10000);
    },
    sendIcamRequest(row){
      let _this = this;
      axios.post(route('modules.gm.richiestaICAM'), { row: row, type: 'purchaseDocDetail' }).then((response) => {
        if (response.data.success) {
          _this.showToast(_this.$t('gm.icam_request_sent_successfully'), 'success');
          _this.updateIcamStatus();
        }
      }).catch((error) => {
        this.showToast(this.$t('core.error'), 'error');
      });
    },
    confirmIcamTaken(row){
      let _this = this;
      axios.post(route('modules.gm.confermaICAM'), { row: row, type: 'purchaseDocDetail' }).then((response) => {
        if (response.data.success) {
          _this.showToast(_this.$t('gm.icam_request_sent_successfully'), 'success');
          _this.updateIcamStatus();
        }
      }).catch((error) => {
        this.showToast(this.$t('core.error'), 'error');
      });
    },
    formatLot(progressive) {
      const pattern = this.buildSearchPattern();
      return pattern.prefix + progressive + pattern.suffix;
    },
    printPicking(picking) {

      console.log('Stampa picking list per:', picking);
      const id = picking.PickingSaleDocId;
      
      if (!id) {
        this.showToast("Impossibile trovare l'ID del picking", "error");
        return;
      }

      const url = route('modules.gm.print-picking-list', { DocId: id });
      const win = window.open(url, '_blank');

      if (win) {
          win.focus();
      } else {
          this.showToast("Il browser ha bloccato il popup di stampa", "warning");
      }
    },

    printLabelPicking(picking) {
      const id = picking.PickingSaleDocId;
      
      if (!id) {
        this.showToast("Impossibile trovare l'ID del picking", "error");
        return;
      }

      const url = route('modules.gm.print-picking-label', { DocId: id });
      const win = window.open(url, '_blank');

      if (win) {
          win.focus();
      } else {
          this.showToast("Il browser ha bloccato il popup di stampa", "warning");
      }
    },
  },
  mounted()
  {
    //Primo caricamento
    console.log(this.$attrs.items);
    this.headers = this.$attrs.headers;
    this.sortby = this.$attrs.sortby;
    let _this = this;

    if (this.icam_support){
      setTimeout(this.updateIcamStatus, 10000);
    }

    document.addEventListener('keyup', (e) => {
      if (document.activeElement.tagName == 'BODY')
      {
        if (e.key === 'Enter') {
          if (_this.showBarCodeModal && _this.singlebarcode){
            _this.checkBarcode();
          }
          else{
            _this.searchItemfromBarcode();
          }
        } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
          if (_this.showBarCodeModal && _this.singlebarcode){
            _this.tmpBarcode += e.key;
          }
          else{
            _this.barcodeSearch += e.key;
          }
        }
      }
    });
  }
};
</script>